import { render, staticRenderFns } from "./roles.vue?vue&type=template&id=23243913&"
import script from "./roles.vue?vue&type=script&lang=ts&"
export * from "./roles.vue?vue&type=script&lang=ts&"
import style0 from "./roles.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports